import React, { Component } from "react";
import "./MetaData.css";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import firebase from "../firebase";
import { MOTHER_TONGUE, STATES, GENDERS, MONTHS, MODAL_FIELDS, REC_LANGUAGES } from "../utils/Constants";
class MetaData extends Component {
  state = { showModal: true, docs: null };
  gettingDoc = false;
  languages = REC_LANGUAGES;
  gender = GENDERS;
  origin = STATES;
  mt = MOTHER_TONGUE;
  componentDidMount = () => {
    this.setState({ showModal: true });
    window.scrollTo(-100, -100);
    this.props.handleSuccessfulToggle();
  };
  render() {

    return (
      <div
        className="container"
        style={{
          display:
            this.props.appState.currentPage === "meta" ? "block" : "none",
        }}
      >
        <Modal
          show={
            this.props.appState.showModal &&
            this.props.appState.currentPage === "meta" &&
            this.props.appState.isLoggedIn &&
            !this.props.appState.isSubProvider &&
            this.props.appState.isExistingSubject
          }
          onHide={(e) => this.props.unsetModal(e)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Choose the existing subject</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              /* {this.props.appState.currentPage === "meta" &&
            this.props.appState.isExistingSubject
              ? this.getModal()
              : null} */
              !!this.props.appState.docs ? (
                this.props.appState.docs.map((subDocs) => (
                  <button
                    className="btn btn-primary btn-block"
                    key={subDocs.data().subjectId}
                    id={subDocs.data().subjectId}
                    subname={subDocs.data().name}
                    onClick={(e) => this.props.clickExistingUser(e)}
                  >
                    {this.getUserString(subDocs.data())}
                  </button>
                ))
              ) : (
                  <h1>No subjects were found under this log-in</h1>
                )
            }
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={(e) => this.props.unsetModal(e)}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="flex-container">
          <form onSubmit={(e) => this.props.handleSubmit(e)} className="white">
            <h1>Please fill the Form below</h1>
            <div style={{
              display: this.props.appState.isLoggedIn ? "block" : "none",
            }}>
              <div>
                <small>Are you recording your own voice?</small>
              </div>
              <div className="toggle-switch form-group">
                <input
                  type="checkbox"
                  className="toggle-switch-checkbox"
                  name="toggleSwitch"
                  id="isSubProvider"
                  defaultChecked={true}
                  onChange={(e) => this.props.handleToggle(e)}
                />
                <label className="toggle-switch-label" htmlFor="isSubProvider">
                  <span className="toggle-switch-inner"></span>
                  <span className="toggle-switch-switch"></span>
                </label>
              </div>
            </div>
            <div
              style={{
                display: this.props.appState.isSubProvider ? "none" : "block",
              }}
            >
              <div>
                <small>
                  Is the subject you are helping a returning subject?
                </small>
              </div>
              <div className="toggle-switch form-group">
                <input
                  type="checkbox"
                  className="toggle-switch-checkbox"
                  name="toggleSwitch"
                  id="isExistingSubject"
                  onChange={(e) => this.props.handleToggle(e)}
                />
                <label
                  className="toggle-switch-label"
                  htmlFor="isExistingSubject"
                >
                  <span className="toggle-switch-inner"></span>
                  <span className="toggle-switch-switch"></span>
                </label>
              </div>
            </div>

            {this.handleMetaAvailability()}
            <div
              style={{
                display: this.props.appState.metaDataAvailable
                  ? "none"
                  : "block",
              }}
            ></div>

            <div className="form-group required">
              <label htmlFor="dropdown" className="control-label">
                Recording Language
              </label>
              <Dropdown
                id="dropdown"
                onSelect={(a, b) => {
                  document.getElementById("lang").innerHTML = a;
                  this.props.handleChange({
                    target: { id: "language", value: a },
                  });
                }}
              >
                <Dropdown.Toggle variant="secondary" id="lang">
                  Language
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu">
                  {this.languages.map((lang) => (
                    <Dropdown.Item eventKey={lang} key={lang}>
                      {lang}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              {this.props.appState.langError ? (
                <div style={{ fontsize: 10, color: "red" }}>
                  {this.props.appState.langError}
                </div>
              ) : null}
            </div>

            {/* <div className="input-field form-group">
              <label htmlFor="dropdown" className="control-label">
                Identification aid (optional)
              </label>
              <br></br>
              <input
                type="file"
                id="identification"
                onChange={(e) => this.props.handleChange(e)}
                className=""
                placeholder="id"
              />
              <br></br>
              <small>Identification document for age (student ID card, Aadhaar card etc)</small>
            </div> */}

            <div className="flex-container input-field form-group" >
              <button
                className="btn btn-dark"
                onClick={(e) => this.props.handleSubmit(e)}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  getUserString = (subObj) => {
    let userString = "";
    Object.keys(MODAL_FIELDS).forEach((field) => {
      userString = userString + MODAL_FIELDS[field] + " : " + subObj[field] + ";";
    });
    return userString;
  };

  getModal = () => {
    if (!!this.props.appState.docs) {
      return this.languages.map((lang) => (
        <button className="btn btn-primary btn-block" key={lang} id={lang}>
          {lang}
        </button>
      ));
    } else {
      return <h1>No subjects were found under this log-in</h1>;
    }
  };

  getDocs = () => {
    firebase
      .firestore()
      .collection("users")
      .doc(this.props.appState.providerId)
      .collection("subjects")
      .get()
      .then((snapshot) => {
        let documents = snapshot.docs;
        this.setState({ docs: documents });
      });
  };

  handleMetaAvailability = () => {
    var age = [];
    for (var i = 0; i <= 150; i++) {
      age.push(i);
    }
    // this.origin.sort();
    if (!!this.props.appState.metaDataAvailable) return null;
    else
      return (
        <div className="row">
          {/* <div className="input-field form-group">
            <label htmlFor="anonId" className="control-label">
              Returning ID
            </label>
            <input
              type="anonId"
              id="anonId"
              onChange={(e) => this.props.handleChange(e)}
              className="form-control"
              placeholder={this.props.appState.anonId}
            />
            <small>
              Please paste your ID if you are a returning anonymous subject
            </small>
          </div> */}
          <div className="input-field form-group required col-md-6">
            <label htmlFor="name" className="control-label">
              Name
            </label>
            <input
              type="name"
              id="name"
              onChange={(e) => this.props.handleChange(e)}
              className="form-control"
              placeholder={this.props.appState.name}
            />
          </div>
          <div className="col-md-6">

          </div>
          <div className="input-field form-group required col-md-6">
            <label htmlFor="yob" className="control-label">
              Year of birth
            </label>
            <input
              id="yob"
              type="number"
              placeholder={2000}
              className="form-control"
              onChange={(e) => this.props.handleChange(e)}
            ></input>
            {this.props.appState.yobError ? (
              <div style={{ fontsize: 10, color: "red" }}>
                {this.props.appState.yobError}
              </div>
            ) : null}


          </div>
          <div className="form-group required col-md-6">
            <label htmlFor="dropdown" className="control-label">
              Month of birth
            </label>
            <Dropdown
              id="dropdown"
              onSelect={(a, b) => {
                document.getElementById("mob").innerHTML = a;
                this.props.handleChange({
                  target: { id: "mob", value: a },
                });
              }}
            >
              <Dropdown.Toggle variant="secondary" id="mob">
                Month of birth
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdown-menu">
                {MONTHS.map((month) => (
                  <Dropdown.Item eventKey={month} key={month}>
                    {month}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {this.props.appState.mobError ? (
              <div style={{ fontsize: 10, color: "red" }}>
                {this.props.appState.mobError}
              </div>
            ) : null}
          </div>
          <div className="input-field form-group required col-md-6">
            <label htmlFor="school" className="control-label">
              School Name
            </label>
            <input
              id="school"
              type="text"
              className="form-control"
              onChange={(e) => this.props.handleChange(e)}
            ></input>
            <small>Please write NA if the field is not applicable</small>
            {this.props.appState.schoolError ? (
              <div style={{ fontsize: 10, color: "red" }}>
                {this.props.appState.schoolError}
              </div>
            ) : null}
          </div>
          <div className="input-field form-group required col-md-6">
            <label htmlFor="croom" className="control-label">
              Class
            </label>
            <input
              id="croom"
              type="text"
              className="form-control"
              onChange={(e) => this.props.handleChange(e)}
            ></input>
            <small>Indicate your section as well, for example, 6A</small>
            <br></br>
            <small>Please write NA if the field is not applicable</small>
            {this.props.appState.croomError ? (
              <div style={{ fontsize: 10, color: "red" }}>
                {this.props.appState.croomError}
              </div>
            ) : null}
          </div>
          <div className="form-group required col-md-2">
            <label htmlFor="dropdown" className="control-label">
              Origin
            </label>
            <Dropdown
              id="dropdown"
              onSelect={(a, b) => {
                document.getElementById("origin").innerHTML = a;
                this.props.handleChange({
                  target: { id: "origin", value: a },
                });
              }}
            >
              <Dropdown.Toggle variant="secondary" id="origin">
                Origin
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdown-menu">
                {this.origin.map((origin) => (
                  <Dropdown.Item eventKey={origin} key={origin}>
                    {origin}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {this.props.appState.originError ? (
              <div style={{ fontsize: 10, color: "red" }}>
                {this.props.appState.originError}
              </div>
            ) : null}
          </div>

          <div className="form-group required col-md-4">
            <label htmlFor="dropdown" className="control-label">
              Native Language (Mother tongue)
            </label>
            <Dropdown
              id="dropdown"
              onSelect={(a, b) => {
                document.getElementById("mt").innerHTML = a;
                this.props.handleChange({
                  target: { id: "mt", value: a },
                });
              }}
            >
              <Dropdown.Toggle variant="secondary" id="mt">
                Native Language (Mother Tongue)
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdown-menu">
                {this.mt.map((mt) => (
                  <Dropdown.Item eventKey={mt} key={mt}>
                    {mt}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {this.props.appState.mtError ? (
              <div style={{ fontsize: 10, color: "red" }}>
                {this.props.appState.mtError}
              </div>
            ) : null}
          </div>
          <div className="">

          </div>

          <div className="form-group required col-md-2">
            <label htmlFor="dropdown" className="control-label">
              Gender
            </label>
            <Dropdown
              id="dropdown"
              onSelect={(a, b) => {
                document.getElementById("gender").innerHTML = a;
                this.props.handleChange({
                  target: { id: "gender", value: a },
                });
              }}
            >
              <Dropdown.Toggle variant="secondary" id="gender">
                Gender
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdown-menu">
                {this.gender.map((g) => (
                  <Dropdown.Item eventKey={g} key={g}>
                    {g}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {this.props.appState.genderError ? (
              <div style={{ fontsize: 10, color: "red" }}>
                {this.props.appState.genderError}
              </div>
            ) : null}
          </div>
          {/* <div className="input-field form-group">
            <label htmlFor="phoneNo">Phone Number</label>
            <input
              type="phoneNo"
              id="phoneNo"
              onChange={(e) => this.props.handleChange(e)}
              className="form-control"
              placeholder={this.props.appState.phoneNo}
            />
            <div style={{ fontsize: 10, color: "red" }}>
              {this.props.appState.phoneNoError}
            </div>
          </div>
          <div className="input-field form-group">
            <label htmlFor="email" className="control-label">
              Email
            </label>
            <input
              type="email"
              id="email"
              onChange={(e) => this.props.handleChange(e)}
              className="form-control"
              placeholder={this.props.appState.email}
              required
            />
            <div style={{ fontsize: 10, color: "red" }}>
              {this.props.appState.emailError}
            </div>
          </div> */}
        </div >
      );
  };
}
export default MetaData;
